import * as Yup from 'yup'
import { Form, Col } from 'react-bootstrap'
import { CustomFormControl, Textarea } from '../../../../StyledComponents';
import { checkText } from '../ValidationRules';

export const Schema = (settings) => Yup.object().shape({
    nonAcademicCommitment: checkText(settings),
});

export const NonAcademicCommitmentSubForm = ({ form: { values, handleBlur, handleChange, touched, errors }, ...props }) => {
    const { colors, settings } = props;
    return (
        <>
            <Form.Group as={Col} controlId="nonAcademicCommitment" style={{ marginTop: "16px" }}>
                <Form.Label>Außeruniversitäres Engagement</Form.Label>
                <CustomFormControl
                    as={Textarea}
                    colors={colors}
                    placeholder="Außeruniversitäres Engagement"
                    type="text"
                    name="nonAcademicCommitment"
                    value={values.nonAcademicCommitment}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    isValid={touched.nonAcademicCommitment && !errors.nonAcademicCommitment}
                    isInvalid={errors.nonAcademicCommitment}
                    maxLength={settings.textInputLimit}
                />
                <Form.Control.Feedback type="invalid" style={{ display: "block" }}>
                    {errors.nonAcademicCommitment}
                </Form.Control.Feedback>
            </Form.Group>
        </>
    );
};